import React, { useState } from 'react';
import cn from 'classnames';
import { Dropdown, Icon } from 'antd';
import SimpleButton from '../SimpleButton/SimpleButton';
import DropdownMenu from './DropdownMenu';
import styles from './DropdownButton.module.scss';

const DropdownButton = ({
  text,
  textColor,
  buttonClassName,
  menuItems,
  stageMassAction,
  onMenuClick,
  idKey,
  contentKey,
  menuClassName,
  menuItemClassName,
  menuProps,
  children,
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  const handleMenuClick = (e) => {
    setVisible(false);

    onMenuClick && onMenuClick(e);
  };

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const overlay = (
    <DropdownMenu
      onMenuClick={handleMenuClick}
      items={menuItems}
      stageMassAction={stageMassAction}
      idKey={idKey}
      contentKey={contentKey}
      menuClassName={menuClassName}
      itemClassName={menuItemClassName}
      {...menuProps}
    />
  );

  const getPopupContainer = () =>
    document.getElementById('HousingStockContainer');

  return (
    <Dropdown
      overlay={overlay}
      getPopupContainer={getPopupContainer}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      {...props}
    >
      {children || (
        <SimpleButton
          text={text}
          textColor={textColor}
          icon={<Icon type="down" />}
          className={cn(styles.button, buttonClassName)}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </Dropdown>
  );
};

export default DropdownButton;
